import { Control, Controller, FieldError, FieldValues, Path, RefCallBack } from 'react-hook-form';
import React, { ReactNode } from 'react';

interface IProps<T extends FieldValues> {
  name: Path<T>;
  control?: Control<T>;
  children: (fieldProps: {
    value: never; // This is a placeholder for the actual type
    onChange: (value: T[Path<T>]) => void;
    onBlur: () => void;
    ref: RefCallBack;
    error?: FieldError;
  }) => ReactNode;
}

const ControllerWrapper = <T extends FieldValues>({ name, children }: IProps<T>) => (
  <Controller
    name={name}
    render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => {
      const child = children({ value, onChange, onBlur, ref, error });
      if (React.isValidElement(child)) {
        return child;
      }
      return <div />; // return a default ReactElement instead of null
    }}
  />
);

export default ControllerWrapper;
